import { AfterViewInit, Input, OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { fadeIn, fadeOut } from 'src/app/animations';
import { ContactType } from 'src/app/models/enum/contact-type.enum';
import { Job } from 'src/app/models/job.model';
import { UserContactInfo } from 'src/app/models/user-contact-info.model';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';
import { ActionsPlaceholderSettings } from 'src/app/models/enum/actions-placeholder-settings.enum';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';
import { sortBy } from 'lodash-es';


@Component({
	selector: 'contacts-list',
	templateUrl: './contacts-list.component.html',
	styleUrls: ['./contacts-list.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss', '../../stylesheets/job-contacts.scss'],
	animations: [fadeIn(300), fadeOut(300)]
})
export class ContactsListComponent implements OnInit, OnDestroy, AfterViewInit {

	@Input() public contacts: UserContactInfo[] = [];
	@Input() public pageTitle: string;
	@Input() public isInline = false;
	@Input() public noContactsMessage: string;

	public formModel: FormGroup;
	public isLoading = false;

	public self = this;
	public job: Job;
	public customerPreferences: SettingsPreferences;

	public readonly ButtonIcons = ButtonIcons;
	public readonly ContactType = ContactType;
	public readonly ActionsPlaceholderSettings = ActionsPlaceholderSettings;

	private unsubscriber$: Subject<void> = new Subject<void>();

	constructor(
		private activatedRoute: ActivatedRoute,
	) { }

	ngOnInit(): void {
		this.customerPreferences = this.activatedRoute.snapshot.data.customerPreferences as SettingsPreferences;

		if (!this.contacts.length) {
			this.contacts = (this.activatedRoute.snapshot.data.contacts || []) as UserContactInfo[];
			this.contacts = sortBy(this.contacts, [
				(item: UserContactInfo) => item.lastName.toLowerCase(),
				(item: UserContactInfo) => item.firstName.toLowerCase()
			]);
		}

		if (!this.pageTitle) {
			this.pageTitle = this.activatedRoute.snapshot.data.pageTitle;
		}

		if (!this.noContactsMessage) {
			this.noContactsMessage = this.activatedRoute.snapshot.data.noContactsMessage;
		}
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}

}
